import React, { useState, useEffect, useMemo } from "react";
import { NavLink } from "react-router-dom";
import { Grid, TextField, LinearProgress, Button, Fade } from "@mui/material";
import ReactPaginate from "react-paginate";
// COMPONENTS
import Layout from "../../Components/Common/Layout";
import Table from "../../Components/Common/Table/Table";
import TableActions from "../../Components/Common/Table/TableActions";
// FUNCTIONS
import {
  CommonSubHeader,
  getInfoMessageNoResultsSearch,
} from "../../Components/helpers/Helpers";
import { AddBusiness } from "@mui/icons-material";
import api from "../../api/axios";
import LoadingPage from "../../Components/Common/Loading/LoadingPage";
import { ChevronLeft, ChevronRight } from "lucide-react";

function Companies() {
  const [companies, setCompanies] = useState([]);
  const [objPerPage, setObjPerPage] = useState(10);
  const [totalPagesNumber, setTotalPagesNumber] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [pagePressed, setPagePressed] = useState(1);
  const [loading, setLoading] = useState(false);
  const [changeDone, setChangeDone] = useState(false);

  const getDataCompanies = async () => {
    setLoading(true);
    try {
      const { data } = await api.post(
        `${process.env.REACT_APP_API_URL}/companies`,
        {
          page: pagePressed,
          objPerPage,
        },
      );

      console.log(data);

      const { data: companies, total, last_page } = data.companies;

      setCompanies(companies);
      setTotalPagesNumber(total);
      setPageCount(last_page);
    } catch (error) {
      console.error("Error en la respuesta del servidor:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getDataCompanies();
  }, [pagePressed, objPerPage, changeDone]);

  const handlePageClick = (event) => {
    setPagePressed(event.selected + 1);
  };

  const renderLogoCell = (value) => {
    console.log(value);

    return (
      <div className="spanClassForTables centerContent">{ImageCell(value)}</div>
    );
  };

  const ImageCell = (value) => {
    const [esImagenValida, setEsImagenValida] = useState(null);
    const url = `${process.env.REACT_APP_BACKEND_HOST}/storage/company/${value.id}/${value.logo}`;

    useEffect(() => {
      if (!url) return;

      const img = new Image();

      img.onload = () => setEsImagenValida(true);
      img.onerror = () => setEsImagenValida(false);
      img.src = url;

      // Opcional: limpiar cuando el componente se desmonta
      return () => {
        img.onload = null;
        img.onerror = null;
      };
    }, [url]);

    if (esImagenValida === null) {
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "50px",
            minWidth: "350px",
          }}></div>
      );
    }

    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "50px",
          minWidth: "350px",
        }}>
        {esImagenValida === false ? (
          <div style={{ height: "50px" }}></div>
        ) : (
          <Fade in timeout={800}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}>
              <img src={url} alt="Company logo" style={{ height: "50px" }} />
            </div>
          </Fade>
        )}
      </div>
    );
  };

  const renderCompanyNameCell = (value) => (
    <div className="spanClassForTables centerContent">{value}</div>
  );

  const renderCifCell = (value) => (
    <div className="spanClassForTables centerContent">
      {value || "Sin asignar"}
    </div>
  );

  const columns = useMemo(
    () => [
      {
        Header: "LISTA DE EMPRESAS",
        columns: [
          {
            Header: "Logo",
            accessor: "company_logo",
            Cell: ({ value }) => renderLogoCell(value),
          },
          {
            Header: "Empresa",
            accessor: "company_name",
            Cell: ({ value }) => renderCompanyNameCell(value),
          },
          {
            Header: "CIF",
            accessor: "company_cif",
            Cell: ({ value }) => renderCifCell(value),
          },
          {
            Header: "Acciones",
            accessor: "id",
            Cell: ({ value }) => (
              <TableActions
                rute={"empresas"}
                apiRute={"companies"}
                setChangeDone={setChangeDone}
                changeDone={changeDone}
                value={value}
                showView
                showDelete
                showEdit
                module="company"
              />
            ),
          },
        ],
      },
    ],
    [],
  );

  useEffect(() => {
    if (pagePressed > pageCount) {
      setPagePressed(1);
    }
  }, [pageCount]);

  return (
    <div className="fatherContainer">
      <CommonSubHeader title="Configuración" subTitle="Empresas" />

      <div className="mainContainer">
        <div className="subMainContainer">
          {loading && <LoadingPage isLoading={loading} heightProp={"60vh"} />}
          <div>
            {!loading && companies && (
              <Table
                columns={columns}
                data={companies}
                view="empresa"
                viewTitle="empresas"
                totalPagesNumber={totalPagesNumber}
                tableWidth={"unset"}
                icon={AddBusiness}
                viewPermission={"company"}
              />
            )}
            {totalPagesNumber > 10 && (
              <div className="tablePaginateContainer">
                <div className="paginatorLeftText">
                  Mostrando {objPerPage * (pagePressed - 1) + 1} a{" "}
                  {Math.min(objPerPage * pagePressed, totalPagesNumber)} de{" "}
                  {totalPagesNumber} resultados
                </div>

                <ReactPaginate
                  breakLabel="..."
                  nextLabel={<ChevronRight size={18} />}
                  previousLabel={<ChevronLeft size={18} />}
                  onPageChange={handlePageClick}
                  pageRangeDisplayed={3}
                  marginPagesDisplayed={2}
                  pageCount={pageCount}
                  containerClassName="pagination"
                  activeClassName="active"
                  pageClassName="page-item"
                  nextClassName="page-item"
                  previousClassName="page-item"
                  disabledClassName="disabled"
                  forcePage={pagePressed - 1} // Esto sincroniza el botón activo
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Companies;
